<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.99523,0C3.57787,0,0,3.57787,0,7.99523C0,12.4126,3.57787,15.9905,7.99523,15.9905C12.4126,15.9905,15.9905,12.4126,15.9905,7.99523C15.9905,3.57787,12.4126,0,7.99523,0C7.99523,0,7.99523,0,7.99523,0ZM11.703,9.70434C11.703,9.70434,8.70475,12.7025,8.70475,12.7025C8.52486,12.8824,8.275,12.9924,7.99517,12.9924C7.71534,12.9924,7.46549,12.8824,7.28559,12.7025C7.28559,12.7025,4.28738,9.70434,4.28738,9.70434C4.10749,9.52445,3.99756,9.27459,3.99756,8.99476C3.99756,8.44509,4.44729,7.99536,4.99696,7.99536C5.27679,7.99536,5.52664,8.10529,5.70654,8.28518C5.70654,8.28518,6.99577,9.57442,6.99577,9.57442C6.99577,9.57442,6.99577,3.99774,6.99577,3.99774C6.99577,3.44807,7.4455,2.99834,7.99517,2.99834C8.54484,2.99834,8.99458,3.44807,8.99458,3.99774C8.99458,3.99774,8.99458,9.58441,8.99458,9.58441C8.99458,9.58441,10.2838,8.29518,10.2838,8.29518C10.4637,8.11529,10.7135,8.00535,10.9934,8.00535C11.5431,8.00535,11.9928,8.45508,11.9928,9.00476C11.9928,9.27459,11.8829,9.52445,11.703,9.70434C11.703,9.70434,11.703,9.70434,11.703,9.70434Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Download',
} as DefineComponent
</script>
